import React from 'react'
import PlayerName from './PlayerName'

const ScoreList = (props) => {
  const playerlist = props.map((player) => {
    return PlayerName(player);
  });

  return (
    <table align="center" className="scoreTable">
      <tbody>
        {playerlist}
      </tbody>
    </table>
  );
}

export default ScoreList;



// WEBPACK FOOTER //
// ./src/components/ScoreList.js